import $ from "jquery";
import Rails from "@rails/ujs";

$(".email-confirmation").each((index, element) => {
  const organizationId = element.getAttribute("data-organization-id");
  const confirmationId = element.getAttribute("data-confirmation-id");

  let retries = 0;
  const confirmEmail = () => {
    if (retries >= 3) {
      window.location = `/organizations/${organizationId}/update_membership`;
    }

    Rails.ajax({
      type: "POST",
      url: `/organizations/${organizationId}/email_change_confirmations/${confirmationId}/confirm`,
      success: (data) => (window.location = `/organizations/${organizationId}`),
      error: () => confirmEmail(),
    });

    retries += 1;
  };

  confirmEmail();
});
